import * as yup from 'yup'

export const laundryConfigHourSchema = yup.object().shape({
  TipoConfiguracion: yup.string().required('Tipo de configuración es obligatorio'),
  ProveedorId: yup.string().when('TipoConfiguracion', {
    is: (valorCampoTipoConfiguracion) => valorCampoTipoConfiguracion === 'CTLPROVEEDOR',
    then: yup.string().required('El Proveedor es obligatorio'),
    otherwise: yup.string(),
  }),
  SiteId: yup.string().when('TipoConfiguracion', {
    is: (valorCampoTipoConfiguracion) => valorCampoTipoConfiguracion === 'CTLSITE',
    then: yup.string().required('El Site es obligatorio'),
    otherwise: yup.string(),
  }),
  Valor: yup.number()
    .typeError('Valor es requerido')
    .required('Valor es requerido'),
})